import React, { PureComponent } from 'react';
import * as topojson from 'topojson-client';
import { GeoJSON, withLeaflet } from 'react-leaflet';
import L from 'leaflet';

import sichtungen from '~/assets/data/woelfe_sichtungen.json';
import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();

const key = Object.keys(sichtungen.objects)[0];
let geojsonDataSichtungen =  topojson.feature(sichtungen, sichtungen.objects[key])

class SichtungenLayer extends PureComponent {

  state = {
    opacity: 0
  }

  componentDidMount() {
    window.setTimeout(() => this.setState({ opacity: 0.6 }, this.bringToBack()), 1000);
  }

  bringToBack() {
    const layers = this.props.leaflet.map._layers;

    Object.values(layers)
      .filter((layer) => {
        return layer.options.bringToBack;
      })
      .forEach((layer) => {
        layer.bringToBack();
      });
  }

  render() {
    return (
      <GeoJSON
        data={geojsonDataSichtungen}
        fillColor={ isSmallScreen ? "url(#stripes2)" : "url(#stripes2)" }
        fillOpacity={this.state.opacity}
        stroke={false}
        interactive="false"
        className="sichtungen-layer"
        bringToBack
      />
    );
  }
}

export default withLeaflet(SichtungenLayer);
